import { Message, Uploader, useToaster } from 'rsuite';
import React from 'react';
import { FileType } from 'rsuite/esm/Uploader/Uploader';
import { API_DOMAIN } from '../../config';
import { useCsrfHeaders } from '../../common/useCsrfHeaders';

type Props = {
  refreshImages: () => Promise<void>;
  section: {
    id: string;
    name: string;
    nameEn: string;
    nameDe: string;
    active: boolean;
    createdAt: number;
    updatedAt: number;
  };
};

export default function UploadImages({ refreshImages, section }: Props) {
  const [fileList, setFileList] = React.useState<FileType[]>([]);
  const toaster = useToaster();
  const [, setFilesCounter] = React.useState<number>(0);
  const csrfHeaders = useCsrfHeaders();

  const incrementFilesCounter = (amount: number = 1) => {
    setFilesCounter(prevState => prevState + amount);
  };
  const decrementFilesCounter = (amount: number = 1) => {
    setFilesCounter(prevState => {
      const result = Math.max(prevState - amount, 0);
      if (result === 0) {
        toaster.push(
          <Message type="success" showIcon closable>
            Завантаження завершено
          </Message>,
          {
            placement: 'topEnd',
            duration: 1500,
          }
        );
        refreshImages().catch(console.error);
        setTimeout(() => {
          setFileList([]);
        }, 750);
      }
      return result;
    });
  };

  return (
    <div style={{ width: '100%' }}>
      <Uploader
        id={'image-uploader'}
        multiple={true}
        draggable
        listType="picture"
        action={`${API_DOMAIN}/api/gallery/sections/${section.id}/upload`}
        withCredentials={true}
        headers={csrfHeaders}
        name={'image'}
        autoUpload={true}
        fileListVisible={true}
        fileList={fileList}
        onError={(status, file, event, xhr) => {
          let message = 'Помилка завантаження фото';
          if (xhr.responseText) {
            try {
              const body = JSON.parse(xhr.responseText);
              message = body?.message?.message || body?.message || message;
            } catch {
              // backend returned non-JSON (e.g. nginx HTML error page)
            }
          }
          toaster.push(
            <Message type="error" showIcon closable>
              {message}
            </Message>,
            { placement: 'topEnd', duration: 1500 }
          );
        }}
        onSuccess={async (response, file, event, xhr) => {
          decrementFilesCounter();
        }}
        onChange={fileList => {
          setFileList(fileList);
          incrementFilesCounter(fileList.length);
        }}
      >
        <div
          style={{
            width: '100%',
            padding: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderWidth: 2,
          }}
        >
          <span>
            Перетягніть фото або клікніть сюди для завантаження до секціі "
            {section.name}"
          </span>
        </div>
      </Uploader>
    </div>
  );
}
